import * as XLSX from 'xlsx';

export type ExportFormat = 'csv' | 'excel';

export interface ExportOptions {
  filename: string;
  sheetName?: string;
  separator?: string;
}

// Função para sanitizar dados antes do processamento pelo XLSX
const sanitizeData = (data: any[]): any[] => {
  return data.map(item => {
    const sanitizedItem: any = {};
    for (const key in item) {
      if (item.hasOwnProperty(key)) {
        let value = item[key];
        
        // Sanitizar valores perigosos
        if (typeof value === 'string') {
          // Remove caracteres potencialmente perigosos
          value = value.replace(/[<>\"'&]/g, '');
          // Limita o tamanho da string para prevenir ReDoS
          value = value.substring(0, 1000);
        }
        
        // Sanitizar chaves para prevenir prototype pollution
        const sanitizedKey = key.replace(/[^a-zA-Z0-9_]/g, '');
        if (sanitizedKey && sanitizedKey !== '__proto__' && sanitizedKey !== 'constructor' && sanitizedKey !== 'prototype') {
          sanitizedItem[sanitizedKey] = value;
        }
      }
    }
    return sanitizedItem;
  });
};

const createDownloadLink = (blob: Blob, filename: string) => {
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // Limpar URL object para liberar memória
  URL.revokeObjectURL(url);
};

export const exportData = (data: any[], format: ExportFormat, options: ExportOptions) => {
  try {
    // Validar entradas
    if (!Array.isArray(data) || data.length === 0) {
      throw new Error('Dados inválidos para exportação');
    }
    
    if (!options.filename || typeof options.filename !== 'string') {
      throw new Error('Nome do arquivo é obrigatório');
    }

    // Sanitizar dados antes do processamento
    const sanitizedData = sanitizeData(data);
    
    const worksheet = XLSX.utils.json_to_sheet(sanitizedData);
    
    if (format === 'csv') {
      const csv = XLSX.utils.sheet_to_csv(worksheet, { FS: options.separator || ';' });
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      createDownloadLink(blob, `${options.filename}.csv`);
    } else {
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, options.sheetName || 'Sheet1');
      XLSX.writeFile(workbook, `${options.filename}.xlsx`);
    }
  } catch (error) {
    console.error('Erro ao exportar dados:', error);
    throw new Error('Falha na exportação de dados');
  }
};